import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { fetchSinToken } from 'helpers/fetch';
import SLUGS from 'resources/slugs';
//import { rfcValido } from 'resources/utilities';
import videomz from 'images/login/microzync.m4v'
//////imagenes////
//////////////////
import fondo from 'images/login/registro/fondo.png';
import logo from 'images/login/logo.png';
import amazon from 'images/login/recuperacion_contrasena/amazon.png'
import shopify from 'images/login/recuperacion_contrasena/shopify.png'
import mercado_libre from 'images/login/recuperacion_contrasena/mercado_libre.png'
import woocomerce from 'images/login/recuperacion_contrasena/woocomerce.png'
/////////////////
import iconUser from 'images/registro/UserIcon.svg';
import iconTelefono from 'images/registro/TelIcon.svg';
import iconCorreo from 'images/registro/MailIcon.svg';
import iconContrasenia from 'images/registro/PwdIcon.svg';
//import iconRfc from 'images/registro/RFCIcon.svg';
import './Login.css';
import "./Register.css";
import Swal from 'sweetalert2'

const Register = ({ history }) => {
    const [loading, setLoading] = useState(false);
    let [usuario, setUsuario] = useState(['']);
    const { nombre = '', correo = '', pwd = '', confirm_pwd = '', telefono = '' } = usuario;
    const isMobile = window.innerWidth <= 767;
    //let [rfc, setRfc] = useState("");
    let [terminos, setTerminos] = useState(false);
    let [error, setError] = useState(['']);
    let [errores ] = useState({});

    // handle button click of login form
    const handleLogin = () => {
        setError(null);
        setLoading(true);
        console.log(usuario)
        if (!terminos) {
            Swal.fire('Atención', 'Acepte los terminos y condiciones para poder continuar.', 'info')
            setLoading(false);
            return;
        }

        const regex = /^[0-9]{10}$/i;
        if (!regex.test(usuario?.telefono)) {
            Swal.fire('Error', "Escriba un número de teléfono válido", 'error');
            setLoading(false);
            return false;
        }

        if (usuario?.nombre === undefined) {
            Swal.fire('Atención', 'Capture su información para poder continuar.', 'info')
            setLoading(false);
            return;
        }

        if (usuario.nombre === undefined || usuario.nombre?.length === 0) {
            Swal.fire('Atención', 'Escriba su nombre de usuario.', 'info')
            setLoading(false);
            return;
        }

        if (usuario.correo === undefined || usuario.correo?.length === 0) {
            Swal.fire('Atención', 'Escriba su dirección de correo.', 'info')
            setLoading(false);
            return;
        }

        if (usuario.pwd === undefined || usuario.pwd?.length === 0) {
            Swal.fire('Atención', 'Capture una contraseña.', 'info')
            setLoading(false);
            return;
        }

        if (usuario.telefono === undefined || usuario.telefono?.length === 0) {
            Swal.fire('Atención', 'Escriba su teléfono.', 'info')
            setLoading(false);
            return;
        }

        /*if (rfc === undefined || rfc?.length === 0) {
            Swal.fire('Atención', 'Escriba su RFC.', 'info')
            setLoading(false);
            return;
        }

        var rfcCorrecto = rfcValido(rfc, false);
        if (!rfcCorrecto) {
            Swal.fire('Error', 'RFC no válido', 'error');
            setLoading(false);
            return;
        }*/

        if (usuario.confirm_pwd !== usuario.pwd) {
            Swal.fire('Error', 'Las contraseñas no coinciden.', 'error')
            setLoading(false);
            return;
        }

        usuario.rol = {
            id: 2,
            nombre: "Empresa"
        }
        usuario.empresa = {
            rfc: 'XAXX010101000',
            estatus: 'A'
        }
        fetchSinToken('Usuarios', usuario, 'POST')
            .then((response) => {
                setLoading(false);

                if (response.hasOwnProperty('status')) {
                    Object.entries(response.errors).forEach(([ , value]) => {
                        Swal.fire('Error', value[0], 'error')
                        setLoading(false);
                    });
                    return false;
                } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                    Swal.fire('Error', response.mensajes[0], 'error')
                    setLoading(false);
                    return false;
                }
                Swal.fire('Exito', 'Se ha registrado correctamente.', 'success')
                history.push(SLUGS.login);
            })
            .catch((_) => {
                setLoading(false);
            });
    };

    //const handleInputRFC = ({ target }) => {
    //    setRfc(target.value)
    //};

    const handleInputChange = ({ target }) => {

        setUsuario({
            ...usuario,
            [target.name]: target.value
        });

        if ((target.name === 'confirm_pwd' && target.value !== usuario.pwd) || (target.name === 'pwd' && target.value !== usuario.confirm_pwd)) {
            //Swal.fire('Error','Las contraseñas no coinciden.','error')
            setError('Las contraseñas no coinciden.');
        }
        else {
            setError('');
        }
    };

    function check() {
        console.log(terminos);
        setTerminos(!terminos);
        //setOpcion(target.value);
    };

    return (<>

        <div
                className='col-12 col-sm-12 col-md-12 row login' style={{ minHeight: '100vh', marginLeft: '0', textAlign:'center' }} >

                <div
                    className='col-12 col-md-7'
                    style={{
                        
                        backgroundRepeat: 'no-repeat',
                        display: window.innerWidth < 768 ? 'none' : 'block',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        position: 'relative',
                        backgroundColor:'#FAFAFA'
                    }}
                >

                

                    <video src={videomz} loop muted width="100%" id="background-video" height="380" type="video/mp4" autoplay="true" />


                    <div className='text-center' style={{
                        position: 'absolute',
                        top: '75%',
                        left: '50%',
                        height: '30%',
                        width: '80%',
                        margin: '-15% 0 0 -40%'
                    }}
                    >

                    {isMobile ? '' : <>
                        
                        <div style={{ maxWidth: '100%' }}>
                            <h4 className="colorfg text-center"><b>¡Expande tus canales de ventas con Microzync!</b></h4>
                        </div>
                        <br></br>
                        <div style={{ maxWidth: '95%' }}>
                            <p className="colorfg text-center">Conecta tu ecommerce con tu marketplace o tu ERP y sigue vendiendo, microzync se encarga de mantenerlos sincronizados.</p>
                        </div>
                         <br/>
                            <div style={{ maxWidth: '95%' }}>
                            <p> Descarga el Conector <a href="https://microzync.com/assets/sys/SetupMicrozync.zip" target="_blank" rel="noreferrer" className="colorfg text-center"> Contpaqi Microsip Sicar4</a> O <a href="https://microzync.com/assets/sys/MicrozyncSicarX.zip" target="_blank" rel="noreferrer" className="colorfg text-center">SicarX</a> </p>
                        <br/>
                            <a href="https://www.youtube.com/playlist?list=PLI6tu6q0RVx22OB0rkfjairkxsd_UhBTz" target="_blank" rel="noreferrer" className="colorfg text-center">Revisa aquí los videos de ayuda.</a>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <a href="https://microzync.com/documentacion/" target="_blank" rel="noreferrer" className="colorfg text-center">O la base de conocimientos.</a>
                            <br/>

                            </div>
                        <br/>

                    </>}
                    <br />
                
                {isMobile ? '' : <>
                    <div className='col-12 col-sm-12 col-md-12 row text-center' >
                        <div className='col-2 col-sm-3 col-md-3 text-center' style={{ backgroundColor: 'gray', borderTopLeftRadius: '10px' }}>
                            <img src={woocomerce} alt='' style={{ width: '15vh' }} />
                        </div>
                        <div className='col-2 col-sm-3 col-md-3 text-center' style={{ color: 'gray', backgroundColor: 'gray' }}>
                            <img src={amazon} alt='' style={{ width: '15vh' }} />
                        </div>
                        <div className='col-2 col-sm-3 col-md-3 text-center' style={{ color: 'gray', backgroundColor: 'gray' }}>
                            <img src={mercado_libre} alt='' style={{ width: '15vh' }} />
                        </div>
                        <div className='col-2 col-sm-3 col-md-3 text-center' style={{ color: 'gray', backgroundColor: 'gray', borderTopRightRadius: '10px' }}>
                            <img src={shopify} alt='' style={{ width: '15vh' }} />
                        </div>
                    </div>
                </>}

            </div>

        </div>

            <div className='col-12 col-md-5 zz'
                    style={{
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundAttachment: 'fixed',
                        backgroundImage: window.innerWidth < 768 ? `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),url(${fondo})` : 'none',
                        backgroundSize: 'cover',

                    }}
                >
                    <form>
                        <div className='card'>
                            <div>
                                <div className='col-md-12 text-center'>
                                    <Link to={SLUGS.home}><img className='img-fyt' src={window.innerWidth < 768 ? logo : logo} alt=''/></Link>
                                    <h2 style={{ color: '#01295F' }}><b>¡Creación de cuentas!</b></h2>
                                    <div className='col-md-12 text-center'>
                                        <p
                                            style={{
                                                color: window.innerWidth < 768 ? '#2D3277' : '#2D3277',
                                                padding: "0px 10% 0px 10%"
                                            }}
                                        >
                                            Administra tu comercio electrónico.
                                        </p>
                                    </div>
                                </div>
                                <div className='col-md-11 text-center' style={{ paddingBottom: '0px', padding: isMobile ? '0px 30px 0px 30px' : '0px' }}>
                                    <p style={{ color: 'red' }}>{error}</p>
                                    {Object.entries(errores).forEach(([ , value]) => { return (<><p style={{ color: 'red' }}>{value}</p></>); })}
                                    <div className='col-md-12  col-lg-12 col-xl-12 row'>
                                        <div className='col-md-1 col-lg-1 col-xl-1'></div>
                                        <div className='col-md-5 col-lg-5 col-xl-5'>
                                            <div className="text-left">
                                                <div className="input-registro">
                                                    <label className='form-label'>Nombre completo*</label>
                                                    <div className="input-icon-form">
                                                        <img
                                                            className="icon-registro"
                                                            src={iconUser}
                                                            alt="Icono Usuario"
                                                            style={{ width: '4vh', padding: '1vh 5px' }}
                                                        />
                                                        <input
                                                            type='text'
                                                            value={nombre}
                                                            name='nombre'
                                                            className='form-control'
                                                            onChange={handleInputChange}
                                                            placeholder='Juan Perez Lopez'
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="text-left">
                                                <div className="input-registro">
                                                    <label className='form-label'>Tel. Móvil* (10 dígitos)</label>
                                                    <div className="input-icon-form">
                                                        <img
                                                            className="icon-registro"
                                                            src={iconTelefono}
                                                            alt="Icono telefono"
                                                            style={{ width: '4vh', padding: '1vh 5px' }}
                                                        />
                                                        <input
                                                            type='text'
                                                            value={telefono}
                                                            name='telefono'
                                                            className='form-control'
                                                            onChange={handleInputChange}
                                                            placeholder='5564560704'
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="text-left">
                                                <div className="input-registro">
                                                    <label className='form-label'>Correo*</label>
                                                    <div className="input-icon-form">
                                                        <img
                                                            className="icon-registro"
                                                            src={iconCorreo}
                                                            alt="Icono correo"
                                                            style={{ width: '4vh', padding: '1vh 5px' }}
                                                        />
                                                        <input
                                                            type='text'
                                                            value={correo}
                                                            name='correo'
                                                            className='form-control'
                                                            onChange={handleInputChange}
                                                            placeholder='correo@gmail.com'
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {isMobile ? '' : <div className='col-md-12 row text-left' style={{ fontSize: "13px", paddingTop: "1%" }} >
                                                <label>Ya tengo una cuenta, <Link to={SLUGS.login} >Iniciar Sesión</Link></label>
                                            </div>}
                                        </div>
                                        <div className='col-md-6 col-lg-6 col-xl-6'>
                                            <div className="text-left">
                                                <div className="input-registro">
                                                    <label className='form-label'>Contraseña*</label>
                                                    <div className="input-icon-form">
                                                        <img
                                                            className="icon-registro"
                                                            src={iconContrasenia}
                                                            alt="Icono correo"
                                                            style={{ width: '4vh', padding: '1vh 5px' }}
                                                        />
                                                        <input
                                                            type='password'
                                                            value={pwd}
                                                            name='pwd'
                                                            className='form-control'
                                                            placeholder='Contraseña'
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="text-left">
                                                <div className="input-registro">
                                                    <label className='form-label'>Confirme contraseña*</label>
                                                    <div className="input-icon-form">
                                                        <img
                                                            className="icon-registro"
                                                            src={iconContrasenia}
                                                            alt="Icono correo"
                                                            style={{ width: '4vh', padding: '1vh 5px' }}
                                                        />
                                                        <input
                                                            type='password'
                                                            value={confirm_pwd}
                                                            name='confirm_pwd'
                                                            className='form-control'
                                                            placeholder='Contraseña'
                                                            onChange={handleInputChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="text-left"><br /></div>
                                            <div className='text-left'>
                                                <label >
                                                    <input
                                                        type='checkbox'
                                                        className='form-check-input'
                                                        name='matriz'
                                                        role='switch'
                                                        onChange={check}
                                                    />&nbsp;
                                                    Acepto <a href={SLUGS.terminoscondiciones} target="_blank" rel="noreferrer">Términos y condiciones</a>
                                                </label>
                                            </div>
                                            <div className='text-left' style={{ paddingTop: "7px" }}>
                                                <input
                                                    type='button'
                                                    className='btn btn-info button-login'
                                                    value={loading ? 'Cargando...' : 'Crear cuenta'}
                                                    onClick={handleLogin}
                                                    disabled={loading}
                                                    style={{ width: "100%" }}
                                                />
                                            </div>
                                            {isMobile && <div className='col-md-12 row text-left' style={{ fontSize: "13px", paddingTop: "1%" }} >
                                                <label>Ya tengo una cuenta, <Link to={SLUGS.login} >Iniciar Sesión</Link></label>
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ background: 'rgba(245, 245, 245, 1)' }}>
                                    <div className=' col-12 col-sm-12 col-md-12 row text-center' >
                                        <div className='col-4 col-sm-4 col-md-4'>
                                            <a href="https://vetecno.net" target="_blank" rel="noopener noreferrer">VETECNO</a>
                                        </div>
                                        <div className='col-4 col-sm-4 col-md-4'>
                                            <a href={SLUGS.terminoscondiciones} target="_blank" rel="noopener noreferrer">Términos y condiciones</a>
                                        </div>
                                        <div className='col-4 col-sm-4 col-md-4'>
                                            <a href={SLUGS.avisoprivacidad} target="_blank" rel="noopener noreferrer">Aviso de privacidad</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                
            </div>
        </div>
    </>);
};

Register.propTypes = {
    saludo: PropTypes.string
};

Register.defaultProps = {
    subtitulo: 'Soy subtitulo'
};

export { Register };